import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import Api from '../../../services/Api';

const ComponentTypeSelector = ({
  onChanged,
  isMulti,
  selectedId,
}) => {
  const [components, setComponents] = useState([]);

  useEffect(() => {
    Api.get('types/building-components?per_page=200').then((response) => {
      if (response.status === 200) {
        const mappedValues = response.data.data.map(product => ({
          label: `${product.name} [${product.code}]`,
          value: product.id,
        }));
        setComponents(mappedValues);
      }
    });
  }, []);
  let selectedItem;
  if (selectedId) {
    selectedItem = components.find(x => x.value === selectedId);
  }
  return (
    <Select
      isMulti={isMulti}
      options={components}
      value={selectedItem}
      onChange={(value) => {
        if (onChanged) {
          onChanged(value);
        }
      }}
      placeholder="Select Component Type"
    />
  );
};

ComponentTypeSelector.propTypes = {
  onChanged: PropTypes.func,
  isMulti: PropTypes.bool,
  selectedId: PropTypes.number,
};

ComponentTypeSelector.defaultProps = {
  onChanged: undefined,
  isMulti: false,
  selectedId: undefined,
};

export default ComponentTypeSelector;
